import { gql } from '@apollo/client/core';

export const REMOVE_REVISION = gql`
  mutation RemoveRevision($activtiyId: Int) {
    Activity {
      DeleteActivtiy(activtiyId: $activtiyId) {
        Result
      }
    }
  }
`;
